import { DataBean } from "../DataBean";

export class ImportRegistry extends DataBean {

    public COSTANALYSIS = 700;
    public PRODUCTINVENTORY = 701;
    public SETTLEMENT = 702;
    public IMPORTDECLARATION = 703;
    public HANDOVERCERTIFICATE = 704;

    public async getImportRegistry(idimportregistry: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.orange.finance.processcontract.bean.ImportRegistry_getImportRegistry_Number", [idimportregistry]);
    }

    public async getImportRegistryRender(formType: number, page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.advantage.shared.Report_getImportRegistryRender_Number_Number_Number_java.util.Map",
            [formType, page, rows, props]);
    }
    public async getFormRegistryRender(formType: number, page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.advantage.shared.Report_getFormRegistryRender_Number_Number_Number_java.util.Map",
            [formType, page, rows, props]);
    }

    public getFormatExcelByForm(idForm: number, idEmployee: number, typeForm: number): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.advantage.shared.Report_getFormatExcelByForm_Number_Number_Number",
            [idForm, idEmployee, typeForm]
        ).then((resp: any) => {
            const report = resp?.ObjectValue?.DataBeanProperties
                ?? resp?.DataBeanProperties?.ObjectValue?.DataBeanProperties
                ?? resp;

            if (report?.ERR) {
                return Promise.reject(report.ERR);
            }

            return report;
        });
    }

    public async getImportDeclarationReport(page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.advantage.shared.Report_getImportDeclarationReport_Number_Number_java.util.Map", [page, rows, props]);
    }

}
